import api from './api';

const adminService = {
  // User Management
  getUserDetails: async (userId) => {
    const response = await api.get(`/admin/user-details/${userId}`);
    return response.data;
  },

  getAllUsers: async (params) => {
    const response = await api.get('/admin/all-users', { params });
    return response.data;
  },

  downloadUsers: async (params) => {
    const response = await api.get('/admin/all-users/download', {
      params,
      responseType: 'blob',
    });
    return response.data;
  },

  updateUserStatus: async (userId, data) => {
    const response = await api.patch(`/admin/status/${userId}`, data);
    return response.data;
  },

  deleteUser: async (userId) => {
    const response = await api.delete(`/admin/delete/${userId}`);
    return response.data;
  },

  verifyUserKyc: async (userId, data) => {
    const response = await api.patch(`/admin/verify-kyc/${userId}`, data);
    return response.data;
  },

  startReviewKyc: async (userId) => {
    const response = await api.patch(`/admin/start-review-kyc/${userId}`);
    return response.data;
  },

  registerStaff: async (data) => {
    const response = await api.post('/admin/register-staff', data);
    return response.data;
  },

  // Donation Analytics
  getFinancialStats: async () => {
    const response = await api.get('/admin/donation/stats');
    return response.data;
  },

  getDonationAnalytics: async () => {
    const response = await api.get('/admin/donation/analytics');
    return response.data;
  },

  getDonationsList: async (params, isAdmin = false) => {
    const url = isAdmin ? '/admin/donation/admin/list' : '/admin/donation/list'
    const response = await api.get(url, { params });
    return response.data;
  },

  exportDonations: async (params) => {
    const response = await api.get('/admin/donation/export', {
      params,
      responseType: 'blob',
    });
    return response.data;
  },

  approveVoucher: async (id) => {
    const response = await api.post(`/admin/donation/approve-voucher/${id}`);
    return response.data;
  },
};

export default adminService;
